import clsx from 'clsx';
import { ThumbsDown, ThumbsUp } from '@hungryroot/icons';
import { useCustomerRecipeRatingById } from '@hungryroot/ratings';
import { stringNumberToNumberNoDecimal } from '@hungryroot/rdp';
import { type PairingDetail } from '@hungryroot/rest';
import { type PairingWithIngredientDetails } from '../../../../hooks/useEditRecipe/useEditRecipe';
import { getRatingsCount } from './constants';
import styles from '../RDPModal.module.css';

export const useProductInfo = ({
  currentPairing,
  pairingV2,
}: {
  currentPairing: PairingWithIngredientDetails;
  pairingV2: PairingDetail | undefined;
}) => {
  // get nutrition only when pairingV2 is received
  const nutrition = pairingV2?.nutrition;

  const { recipe_score, num_ratings, cooking_time, servings, id } =
    currentPairing;

  const isFavorited = useCustomerRecipeRatingById(id);

  const ratingConfig =
    isFavorited !== undefined
      ? {
          label: 'Rating',
          value: (
            <span
              className={clsx(
                styles['rating-icon'],
                styles[isFavorited ? 'liked' : 'disliked']
              )}
            >
              {isFavorited ? <ThumbsUp /> : <ThumbsDown />}
            </span>
          ),
        }
      : {
          label: 'Rating',
          value: recipe_score
            ? `${stringNumberToNumberNoDecimal(
                recipe_score.toString()
              )}% (${getRatingsCount(num_ratings)})`
            : 'New',
        };

  return [
    ratingConfig,
    {
      label: 'Cook time',
      value: `${cooking_time} min`,
    },
    {
      label: 'Serving',
      value: `${servings}`,
    },
    {
      label: 'Cal per serv.',
      value: `${nutrition?.calories !== undefined ? nutrition?.calories : ''}`,
    },
  ];
};
